import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { CourseTheme } from 'assets/themes/Course';
import { useAppSelector, useAppDispatch } from 'hooks/redux';
import { useState, useEffect } from 'react';
import { manualWatchLesson } from 'services/lesson';
import { connect } from 'react-redux';
import { markLessonAsWatchedReducer } from 'actionCreators/lessons';
import { updateLessonOnModule } from 'redux/modules/slice';

interface IWatchedLessonStyleProps {
  lessonWatched: boolean;
}

interface IProps {
  markLessonAsWatchedReducer: typeof markLessonAsWatchedReducer;
}

const useStyles = (props: IWatchedLessonStyleProps) =>
  makeStyles<CourseTheme>((theme) => ({
    formControlLabel: {
      '& > span': {
        color: props.lessonWatched ? theme.palette.primary.light : 'white',
        fontWeight: 600,
        fontSize: 14,
      },
    },
    formControl: {
      [theme.breakpoints.down('md')]: {
        padding: '5px 20px',
      },
      '& > span': {
        color: props.lessonWatched ? theme.palette.primary.light : 'white',
        fontWeight: 600,
        fontSize: 14,
      },
    },
  }));

const WatchedLesson = ({ markLessonAsWatchedReducer }: IProps) => {
  const lesson = useAppSelector((state) => state.newLesson.lesson);
  const dispatch = useAppDispatch();
  const [lessonWatched, setLessonWatched] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = useStyles({
    lessonWatched,
  })();

  useEffect(() => {
    setLessonWatched(Boolean(lesson.watched));
  }, [lesson]);

  const handleWatchedLesson = async (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setLoading(true);
    await manualWatchLesson(lesson.id, checked);
    dispatch(updateLessonOnModule({ lessonId: lesson.id, data: { watched: checked } }));
    markLessonAsWatchedReducer(lesson.id);
    setLessonWatched(checked);
    setLoading(false);
  };

  if (!lesson.id) {
    return null;
  }

  return (
    <div>
      <div>
        <Grid>
          {lesson.watched === null ? (
            <CircularProgress size={20} />
          ) : (
            <FormControlLabel
              aria-label='Botão marcar aula como concluída'
              className={classes.formControl}
              disabled={loading}
              control={
                <Checkbox
                  checked={lessonWatched}
                  onChange={handleWatchedLesson}
                  value='checked'
                  className={`${!loading && classes.formControlLabel}`}
                  id='lesson-mark-as-concluded'
                />
              }
              label='Marcar aula como concluída'
            />
          )}
        </Grid>
      </div>
    </div>
  );
};
const mapStateToProps = (state: any, props: any) => ({
  ...props,
});

export default connect(mapStateToProps, { markLessonAsWatchedReducer })(WatchedLesson);
